import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useFormikContext } from "formik";

import "./style.scss";
import AddOns from "./view/add-ons";
import Household from "./view/house-hold";
import RenewalOptions from "./view/renewal";
import AccountInfo from "./view/account-info";
import { getCurrency } from "helper/numberFormat";

const SummaryRenewal = ({ showRenewal, addOns }) => {
  const currency = getCurrency();
  const { values } = useFormikContext();
  const [customChecked, setCustomChecked] = useState(false);

  return (
    <Box className="summary-renewal-container">
      {values?.showLastYear && (
        <Box className="summary-renewal__card">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography className="summary-renewal__label heading">
                Last year's dues/pledge category
              </Typography>
              <Typography className="summary-renewal__value desc">
                Sustaining Member
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className="summary-renewal__label heading">
                Last year's dues/pledge amount
              </Typography>
              <Typography className="summary-renewal__value desc">
                {currency}2,500.00
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
      {showRenewal && (
        <RenewalOptions
          customChecked={customChecked}
          setCustomChecked={setCustomChecked}
          values={values?.membershipPricing}
          membershipPriceType={values?.membershipPriceType}
          currency={currency}
        />
      )}
      {addOns && <AddOns values={values?.addOns} />}
      {values?.validateContacts && <AccountInfo />}
      {values?.enableHouseHold && <Household data={values?.formTags} />}
    </Box>
  );
};

export default SummaryRenewal;
